import { RootState } from 'store/root-reducer';

export const managerSummarySelector = ({ manager }: RootState) => manager.summary;

export const managerOptionSelector = ({ jobTemplate }: RootState) => jobTemplate.options;

export const enableAreaManagerOptionsSelector = ({ manager }: RootState) =>
  manager.enabledAreaManagerOptions;
